import { ExIconButton, IconButtonSize, IconButtonType } from '@boomi/exosphere';
import { useState, type ReactElement } from 'react';
import VariablePickerModal from './VariablePickerModal';
import classNames from 'classnames';

type Align = 'center' | 'end';

type Props = {
    children: ReactElement;
    onSelect: (variableName: string) => void;
    isVisible: boolean;
    isDisabled?: boolean;
    modalContainer?: HTMLElement | null | undefined;
    align?: Align;
};

const VariablePicker = ({
    children,
    onSelect,
    isVisible,
    isDisabled = false,
    modalContainer,
    align = 'center',
}: Props) => {
    const [isSelectorOpen, setIsSelectorOpen] = useState(false);

    const formatSelectionAndClose = (variableName: string) => {
        setIsSelectorOpen(false);
        onSelect(`{{${variableName}}}`);
    };

    const onHide = () => {
        setIsSelectorOpen(false);
    };

    const classes = classNames({
        flex: true,
        'gap-x-small': true,
        'align-center': align === 'center',
        'align-end': align === 'end',
    });

    if (!isVisible) {
        return children;
    }

    return (
        <>
            <div className={classes}>
                {children}
                <ExIconButton
                    icon="globe-west"
                    type={IconButtonType.SECONDARY}
                    size={IconButtonSize.DEFAULT}
                    onClick={() => setIsSelectorOpen(!isSelectorOpen)}
                    tooltipText="Use an environment variable"
                    data-testid="variable-picker-button"
                    disabled={isDisabled}
                    hideBrowserTooltip
                />
            </div>
            {isSelectorOpen && (
                <VariablePickerModal
                    modalContainer={modalContainer}
                    onSelect={formatSelectionAndClose}
                    onHide={onHide}
                />
            )}
        </>
    );
};

export default VariablePicker;
